/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import PropTypes from 'prop-types';

import { InteractiveComponents } from '../../../core/enums';
import { RootState, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import { Caret } from '../../common';
import { OverlayInteractiveLayerProps } from './OverlayInteractiveLayerProps';

import './OverlayInteractiveLayer.scss';

const OverlayInteractiveLayer: FunctionComponent<OverlayInteractiveLayerProps> = (
    props,
): JSX.Element => {
    const { id } = props;
    const isCaretVisible = useTivoSelector(
        (state: RootState) => state.overlayDialog.isCaretVisible,
    );
    const verticalPosition = useTivoSelector(
        (state: RootState) => state.overlayHighlight.verticalPosition,
    );
    const activeComponent = useTivoSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );

    return (
        <React.Fragment>
            <Caret
                key={`${InteractiveComponents.EAST.toLocaleLowerCase()}-${id}`}
                className="overlay-select-option-caret-east"
                direction={InteractiveComponents.EAST.toLocaleLowerCase()}
                visible={isCaretVisible && id === verticalPosition}
                active={activeComponent === InteractiveComponents.EAST && id === verticalPosition}
            />
            <Caret
                key={`${InteractiveComponents.WEST.toLocaleLowerCase()}-${id}`}
                className="overlay-select-option-caret-west"
                direction={InteractiveComponents.WEST.toLocaleLowerCase()}
                visible={isCaretVisible && id === verticalPosition}
                active={activeComponent === InteractiveComponents.WEST && id === verticalPosition}
            />
        </React.Fragment>
    );
};

OverlayInteractiveLayer.propTypes = {
    id: PropTypes.number.isRequired,
};

export default OverlayInteractiveLayer;
